import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { SplitText } from 'gsap/SplitText'

gsap.registerPlugin(ScrollTrigger, SplitText)

/**
 *   - data-anim-trigger: parent element for the animation
 *   - data-anim: animation type (e.g., 'heading', 'fade')
 *   - data-anim-delay: delay before animation starts (in seconds)
 */

export const initInviewAnimations = () => {
  const animParents = document.querySelectorAll('[data-anim-trigger]')

  animParents.forEach((element) => {
    const animElements = element.querySelectorAll('[data-anim]')
		createTimeline(element, animElements, element.dataset.animOffset, Number(element.dataset.animDelay))
  })
}

const createTimeline = (parent, animElements, offset = '60%', delay = 0) => {
	// console.log('offset', offset)
	const tl = gsap.timeline({
		scrollTrigger: {
			trigger: parent,
			// markers: true,
			start: `top ${offset}`,
			invalidateOnRefresh: true,
			once: true
		}
	})

	console.log('createAnimationTimeline')
	
	parent.dataset.animTrigger = 'ready'

	animElements.forEach((element) => {
		const type = element.dataset.anim
		const delay = parseFloat(element.dataset.animDelay)

		createAnimation(tl, element, type, delay)
	})
}

const createAnimation = (tl, element, type, delay = 0) => {

	console.log('createAnimation', type)

  switch (type) {
		case 'tagline': 
			tl.fromTo(element, {
				clipPath: 'inset(0 50% 0 50%)'
			}, {
				clipPath: 'inset(0 0% 0 0%)',
				duration: 1.8,
				ease: 'expo'
			}, delay)
		break
    case 'heading':

			let split = SplitText.create(element, {
				type: 'lines',
				linesClass: 'line++',
				mask: 'lines'
			})

			tl.fromTo(split.lines, {
				y: '110%',
			}, {
				y: '0%',
				duration: 2,
				stagger: 0.1,
				ease: 'expo.out',
				overwrite: true,
			}, delay)

      break
		case 'text':
			tl.to(element.querySelectorAll('.line'), {
				y: 0,
				duration: 2,
				stagger: 0.06,
				ease: 'expo',
			}, delay)
			break
		case 'fade':
			tl.fromTo(element, {
				opacity: 0,
				y: 150
			}, {
				opacity: 1,
				y: 0,
				duration: 1,
				ease: 'power2.out',
			}, delay)
      break
		case 'image-scale':
			tl.fromTo(element.querySelector('picture'), {
				scale: 1.2,
				opacity: 0,
				filter: 'blur(6px)',
			}, {
				scale: 1,
				opacity: 1,
				filter: 'blur(0px)',
				duration: 1.8,
				ease: 'power2.out',
			}, delay)
			break
  }
}

export default () => {}